import * as actionTypes from "../actions";
const initialState = {
  data: [],
  loading: null
};
const inspections = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STORE_INSPECTION:
      return {
        data: action.data,
        loading: false
      };
    case actionTypes.REQUEST_INSPECTION:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_INSPECTION:
      return Object.assign({}, state);
    default:
      return state;
  }
};
export default inspections;



// WEBPACK FOOTER //
// ./src/redux/reducers/inspections.js